<template>
  <div class="terms-card card-cell">
    <div class="card-hd">行前订商城条款</div>
    <div class="card-bd">
      <div class="bd-box">
        <b>预订须知：</b><br/>
        1、皇家行前订商城仅为游轮上免税店和日妆店（统称为“商店”）商品的展示和预订意向平台，商品的提供、售后等均由商店运营人负责；所有行前订商城意向单的商品由乘客登船后在指定的时间和地点付款和领取。<br/>
        2、皇家行前订商城仅适用于指定的“皇家加勒比国际游轮”中国母港航次，具体以网站实时信息为准。乘客需根据船票预订信息进入皇家行前订商城选择商品并提交意向单，每艘游轮每个航次上的商品和价格会有所不同，乘客仅可选择与其预订航次相对应的商品进行提交。<br/>
        3、皇家行前订商城的商品价格和优惠仅适用于行前订。乘客于登船后进行的预订，以游轮上商店的实际售价为准，商店不定期会有优惠活动，具体活动规则以商店的解释为准。<br/>
        4、皇家行前订商城的商品价格和优惠会不定期进行调整，调整一般不会影响既有意向单中商品的价格和优惠；但如修改意向单，则预订商品的价格将以意向单修改时本网站的实时价格和优惠为准，可能会导致原预订时享受的价格和优惠不再适用。<br/>
        5、乘客登船后未按时付款和领取商品的，均视为自愿取消意向单。<br/>
        6、部分商品会受库存、天气、开航时间、航线变更、公共卫生安全事件、政府政策或管控措施等影响而无法提供，最终结算金额以乘客在游轮上确认的商品为准。<br/>
        7、商品的付款和领取：<br/>
        （1）免税店商品：请乘客登船后携带船卡，在位于5楼的宝格丽珠宝店付款和领取意向单商品。 领取时间为： 第一天登船日晚上18:30 – 22:00以及第二天航海日上午09:00 – 12:00。；<br/>
        （2）日妆店商品：请乘客登船后携带船卡，在位于4楼船中的药妆店付款和领取意向单商品。 领取时间为： 第一天登船日晚上18:30 – 22:00以及第二天航海日上午09:00 – 12:00。<br/>
        8、 划线价：商店运营人根据市场情况制定的建议零售价，并非中国法律法规所定义之“原价”，且可能由商店运营人不时调整。除特别说明外，所有的立减、半价、折扣等优惠活动，均以划线价为计算基础。<br/>
        <b>取消及修改：</b><br/>
        1、意向单的修改或取消：开航日前48小时前，乘客可登录皇家行前订自行修改意向单，或拨打400-820-3187（香港地区乘客请拨打852-6969-0717）由专属客服协助操作取消意向单；开航日前48小时（含）内，乘客可于登船后根据商品的付款和领取指示，至指定的领取地点进行修改或取消。<br/>
        2、如乘客预订的航次因不可抗力、公共卫生安全事件、政府政策或管控措施或游轮公司原因被取消，则对应的行前订意向单自动取消，不收取取消或预订费用；如因前述原因导致乘客变更航次的，原意向单自动取消，乘客需要重新预订新航次的行前订商城商品，商品的价格和优惠以新航次为准，如有疑问，请拨打400-820-3187（香港地区乘客请拨打852-6969-0717）由专属客服协助操作。<br/>
        3、如乘客因其个人原因取消整个舱房的船票预订的，则对应的行前订意向单自动取消，不收取取消或预订费用；乘客取消后重新预订船票的，需以新船票预订信息登入行前订重新进行预订。<br/>
        皇家加勒比国际游轮在法律允许的范围内保留对以上条款的修改及解释权。<br/>
      </div>
    </div>
    <div class="card-bottom">
      <van-checkbox v-model="checked">
        我已接受以上内容条款
        <img
        slot="icon"
        :src="checked ? activeIcon : inactiveIcon"
        >
      </van-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsCard',

  props: {
    termsCheck: Boolean
  },

  data () {
    return {
      activeIcon: require('../../assets/check_ico_on.png'),
      inactiveIcon: require('../../assets/check_ico.png')
    }
  },

  computed: {
    checked: {
      get () {
        return this.termsCheck
      },
      set (val) {
        this.$emit('update:termsCheck', val)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.terms-card{
  .card-bd{
    padding: 30px;
    box-sizing: border-box;
    font-size: 24px;
    color: @main-gray3;
    line-height: 1.8;
    .bd-box{
      height: 5rem;
      overflow-y: auto;
      padding-right: 30px;
    }
  }
  .card-bottom{
    padding: 30px;
    font-size: 24px;
    box-shadow: 0px 0px 40px #bbbbbb;
  }
  ::-webkit-scrollbar{
    width: 4px;
  }
  ::-webkit-scrollbar-track{
    background: #eaeaea;
  }
  ::-webkit-scrollbar-thumb{
    background-color: #fbc300;
  }
}
</style>
